import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppInsightsService } from 'src/app/services/app-insights/appinsights.service';

import { AppStateModel } from './services/+redux/redux.models';
import { IAppInsightsHttpDetails } from './services/app-insights/appInsights.models';
import { TelephonyMemberItem } from './models/telephonyv2';
import { MemberSessionService } from './services/member/member-session.service';

@Injectable()
export class AppErrorHandlerInterceptor implements HttpInterceptor {

    private _window: Window;
    protected get window(): Window {
        if (!this._window) {
            this._window = this.injector.get<Document>(DOCUMENT).defaultView;
        }

        return this._window;
    }

    constructor(private appInsightsService: AppInsightsService, route: ActivatedRoute, private store: Store, private injector: Injector) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let modifiedRequest: HttpRequest<any>;

        const memberContext = this.store.selectSnapshot((state: AppStateModel) => state.memberState.currentSession.memberContext);
        const contexts = this.store.selectSnapshot((state: AppStateModel) => state.memberState.sessionsTracker.contexts);

        if (memberContext?.member) {

            const hash = memberContext.member.$memberHash;
            const memberId = memberContext.member.id;

            let memberTelephonyContext: TelephonyMemberItem;
            let contextIndex: number;

            if (hash) {
                const { contextIndex: contextIndexTemp } = MemberSessionService.getContextByMemberGroupHash(contexts, hash);
                contextIndex = contextIndexTemp;
            }

            if (contextIndex >= 0 && memberId) {
                const inContextMemberIndex = contexts[contextIndex].memberGroup?.findIndex(memberItem => memberItem.id === memberId);
                if (inContextMemberIndex >= 0) {
                    memberTelephonyContext = contexts[contextIndex].memberGroup[inContextMemberIndex];

                    modifiedRequest = request.clone({
                        setHeaders: {
                            'Member-Session-Id': memberTelephonyContext?.telephonyRecordId
                        }
                    });
                }
            }
        }

        return next.handle(modifiedRequest ?? request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    this.processError(request, error);
                    return throwError(error);
                })
            );
    }

    processError(req: HttpRequest<any>, error: HttpErrorResponse) {
        const errorFormatted: any = { message: error.message };
        errorFormatted.cause = error;
        errorFormatted.name = error.message;
        errorFormatted.stack = new Error().stack;

        if (this.appInsightsService) {
            console.error(`Error catched endpoint =>`, error);

            this.appInsightsService.logHttpException(errorFormatted, this.constructor.name, { url: req.url, route: this.window.location.href, payload: req.body, method: req.method, userName: this.store.selectSnapshot((state: AppStateModel) => state.userState?.user?.email), userRole: this.store.selectSnapshot((state: AppStateModel) => state.roleState?.currentRoleName) } as IAppInsightsHttpDetails, undefined, SeverityLevel.Error);
        }
    }
}
